import Service from '../service';
import Request from '../util/request';

export default class Auth {
    public verified: string | null = null;

    public timestamp: number = 0;
    public status: any = null;
    public loading: any = null;
    public session: any = {};

    private readonly authKey: string = 'document-authenticated';
    private readonly sessionKey: string = 'document-session';

    constructor(public service: Service) {
        this.request = new Request();
    }

    public async init() {
        this.loading = true;
        this.timestamp = new Date().getTime();
        this.verified = null;

        try {
            let authenticated = localStorage.getItem(this.authKey) === 'true';
            let raw = localStorage.getItem(this.sessionKey);
            this.session = authenticated && raw ? JSON.parse(raw) : {};
            this.status = authenticated ? true : false;
        } catch (e) {
            this.session = {};
            this.status = false;
        }

        return this;
    }

    public async update() {
        while (this.loading === null) {
            await this.service.render(100);
        }

        let diff = new Date().getTime() - this.timestamp;
        if (diff > 1000 * 60) {
            this.loading = null;
            await this.init();
        }
    }

    public clear() {
        try {
            localStorage.removeItem(this.authKey);
            localStorage.removeItem(this.sessionKey);
        } catch (e) { }
        this.session = {};
        this.status = false;
        this.verified = null;
    }

    public check: any = new Proxy(((root) => {
        let obj: any = () => {
            return this.status;
        }

        obj.root = root;
        return obj;
    })(this), {
        get(target, propKey) {
            let propValue: any = target.root.session[propKey];

            return (values: any = null) => {
                if (values === null) {
                    return true;
                }

                if (typeof values == 'boolean') {
                    if (values === propValue)
                        return true;
                    return false;
                }

                if (typeof values == 'string')
                    values = [values];

                if (values.indexOf(propValue) >= 0) {
                    return true;
                }

                return false;
            };
        }
    });

    public allow: any = new Proxy(((root) => {
        let obj: any = (redirect: any = null) => {
            if (root.check()) return true;
            if (redirect) location.href = redirect;
            return false;
        }

        obj.root = root;
        obj.check = root.check;
        return obj;
    })(this), {
        get(target, propKey) {
            return (values: any = null, redirect: any = null) => {
                if (target.check[propKey](values)) return true;
                if (redirect) location.href = redirect;
                return false;
            }
        }
    });

    public hash(password: string = '') {
        return this.service.crypto.SHA256(password).toString();
    }
}
